import * as React from 'react';
import { FormInput } from 'source/app/presentation/Shared/Form/Input/FormInput';
import MotwLogicServer from 'source/app/services/External/LogicServer/MotwLogicServer';
import * as toastr from 'toastr';

export function YoutubeDownloader() {
	const [ url, setUrl ] = React.useState('');

	return (
		<div>
			<FormInput
				label="Download MP3 from YouTube URL"
				onChange={(event) => setUrl(event.target.value)}
				type="text"
				maxWidth="80%"
				width="500px"
				value={url}
				onEnter={async () => {
					toastr.info(`Requested download from the url '${url}'`);
					setUrl('');

					const response = await MotwLogicServer.PostYoutubeDownloadRequest(
						url
					);

					if (response && response.result) {
						toastr.success(response.result);
					}
				}}
			/>
		</div>
	);
}
